<div class="page-wrapper p-3">
  <div class="container-fluid">
    <div class="row mb-2" style="position: relative">
      <div class="col-xl-3 border-right" style="position: static">
        <!-- <div>left nav</div> -->
        <div class="">
          <app-top5-college-filters
            [selectedNumberOfColleges]="maxUniversityListArr.length"
            (selectctedClg)="filterCollge($event)"
            [filterCollegeItem]="filterCollegeItem"
            [answerMap]="answerMap"
            [deleteBy]="deleteBy"
            [ipedsId]="ipedsId"
            (resetSelectedCollege)="restSearchCollegeItem()"
            (deleteRow)="uncheckedCollege($event, 9999)"
            (resetCollege)="reset()"
          ></app-top5-college-filters>
        </div>
      </div>

      <div class="col-xl-9 col-12">
        <div class="row mt-4 mb-2">
          <div class="col-xs-12 col-sm-12 col-md-12 mb-3">
            <div class="college-search bg-white rounded p-4 shadow-sm m-2">
              <h3 class="mb-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="mr-2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5-15H5.625c-.621 0-1.125.504-1.125 1.125v16.5c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9zm3.75 11.625a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
                  />
                </svg>
                Search your college:
              </h3>
              <div class="serach-in">
                <!-- <input type="search" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Add College"> -->
                <div class="searchfilter">
                  <ng-autocomplete
                    class="mb-2"
                    id="collesearch"
                    [(ngModel)]="searchBoxvalue"
                    (inputChanged)="onChangeSearch($event)"
                    [data]="collegeSearchList"
                    searchKeyword="value"
                    (inputChanged)="getAutoSearchData($event)"
                    [itemTemplate]="itemTemplate"
                    placeholder="Add College"
                    [ngClass]="disabledClass()"
                    (selected)="onSelected($event)"
                  >
                  </ng-autocomplete>
                  <ng-template #itemTemplate let-item>
                    <a innerHTML="{{ item.value }}, {{ item.stateCode }}">
                      {{ item.value }},{{ item.stateCode }}
                    </a>
                  </ng-template>
                  <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                  </ng-template>
                </div>
              </div>
              <div class="counts">
                Selected Colleges:
                <span>{{ selectedUniversityList.length }}/25</span>
              </div>
            </div>
          </div>
        </div>

        <!-- <tui-loader
          [inheritColor]="true"
          [overlay]="true"
          [showLoader]="IsLoadData"
          class="filter-row">  -->
        <div
          class="border-bottom pb-4 mx-2 mb-2 pt-1"
          *ngFor="let college of maxUniversityListArr; let i = index"
        >
          <div class="row mt-4">
            <div class="col-md-5 col-row-main" *ngIf="college.ipedsId">
              <div class="ml-2">
                <h4 class="col-nm d-flex align-items-center mb-0">
                  <img
                    (click)="openCollegeProfile(i)"
                    style="cursor: pointer"
                    *ngIf="college.imageAvailable"
                    [src]="college?.collegeProfileIcon"
                  />
                  <!-- [ngClass]="AddHypen ? 'addhypen' : ''" -->
                  <span
                    (click)="openCollegeProfile(i)"
                    style="cursor: pointer"
                    *ngIf="college.imageAvailable == false"
                    id="randomcolor"
                    [style.backgroundColor]="college.defaultLabelColor"
                  >
                    {{ getFirstAndLastWords(college.name) }}
                  </span>
                  <!-- <img
                    [ngClass]="checkIconStatus(college?.collegeProfileIcon)"
                    [src]="college?.collegeProfileIcon"
                  /> -->
                  <!-- <ng-container *ngIf="college.imageAvailable" ;>
                    <img [src]="college?.collegeProfileIcon" />
                  </ng-container>
                  <ng-container *ngIf="college.imageAvailable == false">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="#f26722"
                      style="
                        display: inline-block;
                        margin-right: 8px;
                        width: 24px;
                        border-radius: 50%;
                        position: relative;
                        top: 7px;
                        right: 10px;
                        transform: scale(1.5);
                      "
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"
                      />
                    </svg>
                  </ng-container> -->
                  <!-- <img
                      src="https://cdn.virtueanalytics.com/cache/college-icon-top5.png"
                    /> -->
                  <!-- <span>{{ college.name }} ({{ college.stateCode }})</span> -->
                  <span
                    [ngxTippy]="htmlTemplate"
                    [tippyProps]="templateRef"
                    [tippyName]="'collegeName' + college.name"
                    (click)="openCollegeProfile(i)"
                    style="cursor: pointer"
                    >{{ college.name }} ({{ college.stateCode }})</span
                  >
                  <template #htmlTemplate>
                    <div class="t-template" #tippyTemplatePassElement>
                      {{ college.name }}
                    </div>
                  </template>
                </h4>
                <div class="acc-rate">
                  <span *ngIf="getAcceptanceRate(college?.ipedsId, i)"
                    >Acceptance Rate
                    <strong
                      >{{ getAcceptanceRate(college?.ipedsId, i) }}%
                    </strong>
                    <span
                      *ngIf="college.control && college.control != 'null'"
                      class="pl-2 pr-2 text-secondary"
                      >|</span
                    >
                  </span>
                  <span *ngIf="college.control && college.control != 'null'">
                    {{ getControlType(college.control) }}

                    <span
                      class="pl-2 pr-2 text-secondary"
                      *ngIf="college?.hbcuCollege"
                      >|</span
                    >
                  </span>
                  <span *ngIf="college?.hbcuCollege">HBCU</span>
                  <span *ngIf="college?.collegeRankInUS">
                    <span class="pl-2 pr-2 text-secondary">|</span>
                    Rank: <strong>{{ college?.collegeRankInUS }} </strong></span
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4 two-one-col" *ngIf="college.ipedsId">
              <div class="awrdletter-tog">
                <div class="let">
                  <button
                    type="button"
                    tooltip="(PDF, JPG, JPEG and PNG files are supported)"
                    class="custom-button"
                    *ngIf="college?.ipedsId"
                    (click)="openvfr(i, college.ipedsId, college?.name)"
                  >
                    <span>
                      <img [src]="checkUploadLetter(college.ipedsId, i)" />
                    </span>
                  </button>
                </div>
                <!-- <div class="tog">
                    <label class="switch">
                      <input
                        type="checkbox"
                        [checked]="
                          checkedStudentResidenceSelectedState(
                            'domicileToggle',
                            i,
                            college?.ipedsId,
                            college?.stateCode.toLowerCase()
                          )
                        "
                        (change)="
                          selectDomicileAndResidency(
                            'domicileToggleChange',
                            i,
                            $event.target.checked,
                            college?.stateCode,
                            college?.ipedsId,
                            'manualchanged'
                          )
                        "
                      />
                      <div class="slider">
                        <span class="in">In State</span>
                        <span class="out">Out State</span>
                      </div>
                    </label>
                  </div> -->
              </div>
            </div>
            <div class="col-md-3 two-one-col" *ngIf="college.ipedsId">
              <app-residency-selction-options
                [pageAnswer]="CollegeSelctionList"
                [options]="getCampusOption(college)"
                [index]="'r' + college?.ipedsId"
                [placeholder]="'Select Campus'"
                (selectChange)="
                  selectDomicileAndResidency(
                    'residencyDropdownChange',
                    i,
                    $event,
                    '',
                    college?.ipedsId,
                    'changed'
                  )
                "
              >
              </app-residency-selction-options>
              <div class="del">
                <img
                  (click)="deleteRowEvent(college, i)"
                  src="https://cdn.virtueanalytics.com/cache/college-del-icon.png"
                />
              </div>
            </div>
          </div>
          <ng-container *ngIf="yearWiseAffinityQuestion[i] != undefined">
            <div
              class="row affiinity-row mt-5"
              *ngIf="
                yearWiseAffinityQuestion[i].length > 0 &&
                yearWiseAffinityQuestion[i] != undefined
              "
            >
              <div class="head col-md-12">Affinity Questions</div>
              <div class="col-md-12 optionp" *ngIf="college?.ipedsId">
                <div class="row">
                  <div
                    class="col-md-6 mb-2 mt-2 css-p label"
                    *ngFor="
                      let ans of yearWiseAffinityQuestion[i];
                      let index = index
                    "
                  >
                    <label
                      for="questions"
                      class="control-label font-normal text-dark"
                      ><span>{{ ans.label }}</span></label
                    >
                    <div class="in-option">
                      <div class="form-check-inline">
                        <app-checkboxoption
                          [pageAnswer]="CollegeSelctionList"
                          [index]="'aq' + college?.ipedsId + '-' + index"
                          (selectChange)="
                            changeAffinityQuestionOption(
                              'ChangeAffinity',
                              i,
                              index,
                              $event
                            )
                          "
                          [name]="i + '-' + index"
                          [options]="ans.options"
                          [Affinityindex]="index"
                          [Universityindex]="i"
                        >
                        </app-checkboxoption>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!--Start >  State Grant -->
          <!-- <ng-container *ngIf="selectedUniversityStateGrant[i] != undefined">
              <div
                class="row affiinity-row mt-5"
                *ngIf="selectedUniversityStateGrant[i].length > 0"
              >
                <div class="head col-md-12">State Grant</div>
                <div class="col-md-12">
                  <div
                    lass="row  mb-2 mt-2"
                    *ngFor="
                      let stateGrant of selectedUniversityStateGrant[i];
                      let index = index
                    "
                  >
                    <div class="in-option">
                      <div>
                        <div class="form-control efc-cl st-grant">
                          <span class="prefix">$</span>
                          
                          <div class="clear">
                            <tui-input-number
                              class="currency-input col-row-in"
                              [prefix]="''"
                              [tuiTextfieldLabelOutside]="'true'"
                              [pseudoHovered]="'true'"
                              [max]="999999999999999"
                              [pseudoFocused]="'true'"
                              [(ngModel)]="stateGrantFieldValue[i]"
                              (ngModelChange)="
                                changeStateGrantAmount(
                                  college.stateCode,
                                  'Change',
                                  college.ipedsId,
                                  $event
                                )
                              "
                            >
                              <input
                                class="out-max"
                                tuiTextfield
                                placeholder="Please enter State Grant"
                              />
                            </tui-input-number>
                            <div class="clear-icon mt-2">
                              <svg
                                _ngcontent-ken-c189=""
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                                (click)="
                                  changeStateGrantAmount(
                                    college.stateCode,
                                    'Change',
                                    college.ipedsId,
                                    null
                                  )
                                "
                              >
                                <path
                                  _ngcontent-ken-c189=""
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                ></path>
                              </svg>
                            </div>
                          </div>
  
              
                          <span
                            *ngIf="
                              !stateGrantFieldValue[i] &&
                              stateGrantFieldValue[i] != 0
                            "
                            class="profile-css"
                            >Please enter State Grant</span
                          >
                        </div>
                        <div class="cal-npc m-btn-cl" >
           
                            
                            <a
                            class="cal-npc-btn"
                            [ngClass]="
                              !stateGrantFieldValue[i] &&
                              stateGrantFieldValue[i] != 0
                                ? ''
                                : 'disabled'
                            "
                            [href]="stateGrant.npcLink"
                            target="_blank"
                            >Calculate</a
                          >
        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container> -->

          <!--End >  State Grant -->

          <!-- EFC -->
          <!-- <ng-container *ngIf="selectedUniversityCSSProfile[i] != undefined">
              <div
                class="row affiinity-row mt-5"
                *ngIf="selectedUniversityCSSProfile[i].length > 0"
              >
                <div class="head col-md-12">CSS Profile</div>
                <div class="col-md-12">
                  <div
                    lass="row  mb-2 mt-2"
                    *ngFor="
                      let ans of selectedUniversityCSSProfile[i];
                      let index = index
                    "
                  >
                    <ng-container
                      *ngIf="selectedUniversityList[i].usingCSSProfile"
                      class="col-12"
                    >
                      <span
                        class="t-demo__btn css-p label"
                        [ngxTippy]="htmlTemplate"
                        [tippyProps]="templateRef"
                        class="text-success labeltoolTip-hover css-p label"
                      >
                        <label
                          for="questions"
                          class="control-label font-normal text-dark"
                          ><span>{{ ans.label }}</span></label
                        >
                      </span>
                      <template #htmlTemplate>
                        <div class="t-template" #tippyTemplatePassElement>
                          <p class="t-template__info text-left">
                            This college may use a CSS methodology for calculating
                            your EFC, this EFC may vary from the EFC calculated
                            using the federal methodology used by us. You can find
                            this EFC value by summing all contributions in your
                            NPC report,
                            <span
                              *ngIf="
                                selectedUniversityList[i]?.importantLink?.npc
                              "
                            >
                              or you can get a fresh calculation here :
                              <a
                                class="labeltoolTip-hover"
                                [href]="
                                  selectedUniversityList[i]?.importantLink?.npc
                                "
                                target="_blank"
                                >{{
                                  selectedUniversityList[i].importantLink.npc
                                }}</a
                              >
                            </span>
                          </p>
                        </div>
                      </template>
                    </ng-container>
                    <div class="in-option">
                      <div>
                        <div class="form-control efc-cl">
                          <span>$</span>
                          <div class="clear">
                            <tui-input-number
                              class="currency-input col-row-in"
                              [prefix]="''"
                              [tuiTextfieldLabelOutside]="'true'"
                              [pseudoHovered]="'true'"
                              [max]="999999999999999"
                              [pseudoFocused]="'true'"
                              maxlength="12"
                              (keypress)="numbersOnly($event)"
                              placeholder="EFC"
                              [(ngModel)]="efcFieldValue[i]"
                              (ngModelChange)="
                                changeCSSEFCProfileAmount(
                                  'ChangeAnswer',
                                  i,
                                  9999,
                                  $event
                                )
                              "
                            >
                              <input
                                class="out-max"
                                tuiTextfield
                                placeholder="Please enter CSS EFC"
                              />
                            </tui-input-number>
                            <div class="clear-icon mt-2">
                              <svg
                                _ngcontent-ken-c189=""
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                                (click)="
                                  changeCSSEFCProfileAmount(
                                    'ChangeAnswer',
                                    i,
                                    9999,
                                    null
                                  )
                                "
                              >
                                <path
                                  _ngcontent-ken-c189=""
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                ></path>
                              </svg>
                            </div>
                          </div>
                          <span
                            *ngIf="efcFieldValue[i] != 0 && !efcFieldValue[i]"
                            class="profile-css"
                            >Please enter CSS EFC</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="align-page-bottom">
  <div class="text-center border-top pt-3">
    <button class="page-btn" (click)="previous()">Previous</button>
    <button
      class="page-btn"
      [disabled]="checkDisableNextBtn()"
      [ngClass]="checkDisableNextBtn() ? 'cursor-not-allowed' : ''"
      (click)="next()"
    >
      Save & Proceed
    </button>
  </div>
</div>
